<template>
    <div>
        <div class="panel-tag mt-3" v-if="totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div class="dataTables_wrapper dt-bootstrap4" v-show="totalEntries != 0">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table id="commissionCategoryTable" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" class="text-center">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="10" class="text-right">
                                    <a class="btn btn-xs btn-outline-primary text-primary" @click="expandAll">{{isExpandAll == 'Expand' ? $t('button_link.expand_all') : $t('button_link.collapse_all')}}</a>
                                </td>
                            </tr>
                        </tbody>
                        <commissionCategoryTable ref="commissionCategoryTable" v-for="(item, i) in commissionItems" :items="item" :outlet="getOutletName(i)" :staffObj="staffObj" :selectedCategory="selectedCategory" :key="i" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll" :selectedPaymentFilter="selectedPaymentFilter"></commissionCategoryTable>
                    </table>
                </div>
            </div>
        </div>
        <div v-show="totalEntries != 0" class="dataTables_info" role="status" aria-live="polite">{{$t('table.pagination_short',{'totalEntries': totalEntries})}}</div>
    </div>
</template>
<script>
import _ from 'lodash';
import CommissionCategoryTable from './Commission_CategoryTable'

export default {
    name: 'commissionCategory',
    components:{
        CommissionCategoryTable
    },
    props:{
        staffObj: { type: Object },
        selectedCategory: { type: Number },
        selectedPaymentFilter: { type: String, default: 'all' },
    },
    data(){
        return{
            totalEntries: 0,
            commissionItems: {},
            staffGroup: {},
            isExpandAll: "Expand",
            isExpandCount: 0,
            fields: [],
        }
    },
    watch: {
        selectedPaymentFilter(val) {
            this.selectedPaymentFilter = val
            this.setTableFields()
        },
    },
    methods:{
        setTableFields() {
            if(this.selectedPaymentFilter === 'all') {
                this.fields = [
                    { key: "index", label: "#"},
                    { key: "", label: ""},
                    { key: "price", label: this.$i18n.t('table.header.item') + this.$i18n.t('table.header.price')},
                    { key: "effort", label: this.$i18n.t('table.header.effort')},
                    { key: "credit", label: this.$i18n.t('subMenu.salon_report_credit')},
                    { key: "cEffort", label: this.$i18n.t('table.header.effort')},
                    { key: "package", label: this.$i18n.t('subMenu.salon_menu_package')},
                    { key: "pEffort", label: this.$i18n.t('table.header.effort')},
                    { key: "totalEffort", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.effort')})},
                    { key: "totalFee", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})}
                ]
            } else if (this.selectedPaymentFilter === '') {
                this.fields = [
                    { key: "index", label: "#"},
                    { key: "", label: ""},
                    { key: "price", label: this.$i18n.t('table.header.item') + this.$i18n.t('table.header.price')},
                    { key: "effort", label: this.$i18n.t('table.header.effort')},
                    { key: "totalFee", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})}
                ]
            } else if (this.selectedPaymentFilter === 'credits') {
                this.fields = [
                    { key: "index", label: "#"},
                    { key: "", label: ""},
                    { key: "credit", label: this.$i18n.t('subMenu.salon_report_credit')},
                    { key: "cEffort", label: this.$i18n.t('table.header.effort')},
                    { key: "totalFee", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})}
                ]
            } else if (this.selectedPaymentFilter === 'package') {
                this.fields = [
                    { key: "index", label: "#"},
                    { key: "", label: ""},
                    { key: "package", label: this.$i18n.t('subMenu.salon_menu_package')},
                    { key: "pEffort", label: this.$i18n.t('table.header.effort')},
                    { key: "totalFee", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})}
                ]
            }
        },

        updateTable(item){
            this.totalEntries = 0;
            // var items = JSON.parse(item); 
            this.commissionItems = _.groupBy(item, 'outletID');
        },
        getOutletName(id){
            var outlets = JSON.parse(this.$store.state.outlets);
            var outletName = "";
            for(var i=0; i<outlets.length; i++){
                if(outlets[i].id == id){
                    outletName = outlets[i].text;
                    break;
                } 
            }
            return outletName;
        },
        setTotalEntries(len){
            this.totalEntries += len;
        },
        expandAll(){
            var isExpand = false;
            if(this.isExpandAll == "Expand"){
                isExpand = true;
                this.isExpandAll = "Collapse"
            }else{
                isExpand = false;
                this.isExpandAll = "Expand"
            }
            var j = 0;
            for(var i in this.commissionItems){
                this.$refs.commissionCategoryTable[j].showAllDetails(i, isExpand);
                j++;
            }
        },
        setExpandAll(status){
            if(status == "Collapse"){
                this.isExpandCount ++;
            }else{
                if(this.isExpandCount != 0)
                this.isExpandCount --;
            }
            var outletExpand = document.getElementById('commissionCategoryTable').querySelectorAll(".outletExpand");
            if(outletExpand.length == this.isExpandCount){
                this.isExpandAll = "Collapse"
                this.isExpandCount = 0
            }else{
                this.isExpandAll = "Expand"
            }
        },
    },
    mounted() {
        this.setTableFields()
    },
}
</script>
<style scoped>
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
</style>